import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServiceRealizationFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServiceRealizationFormStepOne from "./Steps/ServiceRealizationFormStepOne";
import ServiceRealizationFormStepTwo from "./Steps/ServiceRealizationFormStepTwo";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const ServiceRealizationForm = (props) => {
  const theme = useTheme();
  const {
    step,
    setStep,
    update,
    initialValues: _initialValues,
    loadData,
  } = props;

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues,
        inspection: 0,
        repair: 0,
        implementation: 0,
        diagnostics: 0,
        itService: 0,
        distance: _initialValues?.finalCounter - _initialValues?.initialCounter,
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
        distance: _initialValues?.finalCounter - _initialValues?.initialCounter,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  if (!initialValues) return null;

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val }, props)}
      validate={(val) => onValidate({ ...val }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        const { form, values } = formProps;

        const handleTogglePause = async () => {
          const serviceUuid = values?.uuid || initialValues?.uuid;
          if (!serviceUuid) return;

          const workerUuid = values?.technicianOrTeamLeader?.uuid;
          const queryParams =
            !values?.pause && workerUuid ? `?workerUuid=${workerUuid}` : "";

          const response = await GlobalAuthFetch({
            path: `/service/${serviceUuid}/toggle-pause${queryParams}`,
            method: "PATCH",
          });

          if (response?.payload?.status === 200) {
            const updatedService = response.payload.data;
            form.change("pause", updatedService.pause);
            form.change("pauses", updatedService.pauses);

            if (typeof loadData === "function") {
              await loadData();
            }
          }
        };

        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceRealizationForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceRealizationFormStepOne
                {...formProps}
                {...props}
                handleTogglePause={handleTogglePause}
              />
              <ServiceRealizationFormStepTwo
                {...formProps}
                {...props}
                handleTogglePause={handleTogglePause}
              />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceRealizationForm;
